var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"status-badge",style:({ background: _vm.meta.bg, color: _vm.meta.fg })},[_c('span',{staticClass:"status-dot",style:({ background: _vm.meta.dot })}),_vm._v(_vm._s(_vm.meta.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }